<template>
	<div class="dashboard-customizado">
		<div
			v-if="loading"
			class="dashboard-customizado__estado"
		>
			<v-progress-circular
				indeterminate
				color="primary"
				size="40"
			/>
		</div>
		<div
			v-else-if="erro"
			class="dashboard-customizado__estado"
		>
			<p>{{ $t('erroAoCarregarDashboard') }}</p>
		</div>
		<iframe
			v-else
			class="dashboard-customizado__frame"
			:srcdoc="html"
			title="Dashboard Customizado"
		/>
	</div>
</template>

<script>
import { getRelatorioCustomizado } from '../../services/requests/DashBoardRequests'

export default {
	data() {
		return {
			html: '',
			loading: true,
			erro: false,
		}
	},
	computed: {
		// Nome do relatorio vem da rota; mantem 'nanorads' como padrao (comportamento anterior).
		nomeRelatorio() {
			return this.$route.params.nome || 'nanorads'
		},
	},
	watch: {
		// Recarrega ao trocar de relatorio sem sair da rota.
		nomeRelatorio() {
			this.carregarRelatorio()
		},
	},
	created() {
		this.carregarRelatorio()
	},
	methods: {
		carregarRelatorio() {
			this.loading = true
			this.erro = false
			getRelatorioCustomizado(this.nomeRelatorio)
				.then((response) => {
					this.html = response && response.data ? response.data : ''
				})
				.catch(() => {
					this.erro = true
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
}
</script>

<style scoped>
.dashboard-customizado {
	/* Ocupa a area de conteudo entre o header (4rem) e o footer (2.5rem) do Main.vue */
	height: calc(100vh - 4rem - 2.5rem);
	width: 100%;
}

.dashboard-customizado__frame {
	width: 100%;
	height: 100%;
	border: 0;
}

.dashboard-customizado__estado {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}
</style>
